import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { checkTokenValid, decodeToken } from "../utils/token";

export default function AuthBootstrapper({ onReady }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    async function bootstrap() {
      const hasToken = !!localStorage.getItem("token");

      // 토큰 없음 → 로그인으로
      if (!hasToken) {
        if (location.pathname !== "/login") {
          navigate("/login", { replace: true });
        }
        if (typeof onReady === "function") onReady();
        return;
      }

      // 토큰 유효성/리프레시
      const ok = await checkTokenValid();

      // 유효하지 않음 → 로그인으로
      if (!ok) {
        if (location.pathname !== "/login") {
          navigate("/login", { replace: true });
        }
        if (typeof onReady === "function") onReady();
        return;
      }

      const organization = decodeToken(localStorage.getItem("token"))?.organization;
      if (!organization || organization === "NONE") {
        window.alert("계정에 권한이 없습니다.");
        navigate("/login", { replace: true });
        if (typeof onReady === "function") onReady();
        return;
      }

      sessionStorage.setItem("organization", organization);

      // 유효하고, 루트('/')나 로그인 화면이면 기본 페이지로
      if (location.pathname === "/" || location.pathname === "/login") {
        navigate("/user/normal", { replace: true });
      }

      if (typeof onReady === "function") onReady();
    }

    bootstrap();
  }, []);

  // 별도 UI 없이 조용히 동작
  return null;
}
